import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { P24MerchantBusinessTypeList, P24MerchantBusinessType, getP24MerchantBusinessTypeById } from "../../constants/P24MerchantBusinessType";
import { P24MerchantCreationTypeList, P24MerchantCreationType, getP24MerchantCreationTypeById } from "../../constants/P24MerchantCreationType";
import { P24MerchantTradeList, P24MerchantTrade, getP24MerchantTradeById } from "../../constants/P24MerchantTrade";

import { isValidPesel, isValidNip, isValidDigitCount, isValidEmail } from "../../helpers/utils"


/**
 * Nadpisujemy style dla komponentu select, aby dopasowac do zwyklego inputa i zlikwidowac ramke
 */
const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        borderWidth: "0px",
        borderBottom: "1px solid #ccc"
    })
};

/**
 * Komponent z wiadomością walidacyjną
 */
const ValidationMessage = ({ isValid, message }) => {
    if (!isValid) {
        return (
            <div className="w3-text-red">{message}</div>
        )
    }
    return null;
}

//regex dla tylko liczby
const numberOnlyRegExp = new RegExp('^[0-9]+$')
//regex dla tylko liczby lub -
const numberOrDashRegExp = new RegExp('^[0-9-]+$')

/**
 * Formularz dodania/edycji merchanta
 */
class P24MerchantForm extends React.Component {

    state = {
        merchant: this.props.merchant,
        //wybrany rodzaj dzialalnosci jako obiekt
        selectedBusinessType: getP24MerchantBusinessTypeById(this.props.merchant.businessType),
        //wybrana branża jako obiekt
        selectedTrade: getP24MerchantTradeById(this.props.merchant.trade),
        //wybrany typ utworzenia jako obiekt
        selectedCreationType: getP24MerchantCreationTypeById(this.props.merchant.creationType),
        //obiekt zawierający błądy tekstowe formularza w formacie nazwa_pola: tekst błędu
        formFieldError: {},
        //obiekt zawierający informację czy określone pola mają błędy w formacie nazwa_pola: true/false
        formFieldValid: {
        },
        //określa czy cały formalurza jest zwalidowany
        formValid: false
    }

    componentDidMount() {

        //ustawiamy stan walidowanych pól - dla formatki dla tworzenia i edycji
        const merchant = this.state.merchant;

        //walidujemy poszczególne pola
        Object.keys(merchant).forEach(key => this.validateField(key, merchant[key], true))

        //walidujemy cały formularz
        this.validateForm();

    }

    /**
     * Walidacja calego formularza
     */
    validateForm = () => {
        this.setState({
            formValid: Object.values(this.state.formFieldValid).every(element => element === true)
        })

    }

    /**
     * Walidacja poszczególnego pola
     */
    validateField = (fieldName, value, skipFormValidation) => {

        let formFieldError = this.state.formFieldError;
        let formFieldValid = this.state.formFieldValid;
        let selectedBusinessType = this.state.selectedBusinessType;
        let selectedCreationType = this.state.selectedCreationType

        switch (fieldName) {
            case 'p24MerchantId':
                if (selectedCreationType.isP24MerchantRequired) {
                    formFieldValid.p24MerchantId = value > 0;
                    formFieldError.p24MerchantId = formFieldValid.p24MerchantId ? '' : 'Identyfikator jest wymagany';
                } else {
                    formFieldValid.p24MerchantId = true;
                    formFieldError.p24MerchantId = '';
                }

                break;
            case 'name':
                if (selectedCreationType.isNameRequired) {
                    formFieldValid.name = value.length > 0;
                    formFieldError.name = formFieldValid.name ? '' : '';
                } else {
                    formFieldValid.name = true;
                    formFieldError.name = '';
                }

                break;
            case 'phoneNumber':

                if (selectedCreationType.isPhoneNumberRequired) {
                    formFieldValid.phoneNumber = value.length > 0;
                    formFieldError.phoneNumber = formFieldValid.phoneNumber ? '' : '';

                    if (formFieldValid.phoneNumber) {
                        formFieldValid.phoneNumber = value.length === 9;
                        formFieldError.phoneNumber = formFieldValid.phoneNumber ? '' : 'Numer telefonu musi zawierać 9 cyfr';
                    }
                } else {
                    formFieldValid.phoneNumber = true;
                    formFieldError.phoneNumber = '';
                }

                break;
            case 'pesel':

                if (selectedBusinessType.isPeselRequired) {

                    formFieldValid.pesel = value.length > 0;
                    formFieldError.pesel = formFieldValid.pesel ? '' : '';

                    if (formFieldValid.pesel) {
                        formFieldValid.pesel = value.length === 11;
                        formFieldError.pesel = formFieldValid.pesel ? '' : 'Pesel musi zawierać 11 cyfr';
                    }

                    if (formFieldValid.pesel) {
                        formFieldValid.pesel = isValidPesel(value)
                        formFieldError.pesel = formFieldValid.pesel ? '' : 'Pesel jest niepoprawny';
                    }

                } else {
                    formFieldValid.pesel = true;
                    formFieldError.pesel = '';
                }

                break;

            case 'regon':

                if (selectedBusinessType.isRegonRequired) {

                    formFieldValid.regon = value.length > 0;
                    formFieldError.regon = formFieldValid.regon ? '' : '';

                } else {
                    formFieldValid.regon = true;
                    formFieldError.regon = '';
                }

                break;

            case 'krs':

                if (selectedBusinessType.isKrsRequired) {

                    formFieldValid.krs = value.length > 0;
                    formFieldError.krs = formFieldValid.krs ? '' : '';

                } else {
                    formFieldValid.krs = true;
                    formFieldError.krs = '';
                }

                break;

            case 'nip':

                if (selectedBusinessType.isNipRequired) {

                    formFieldValid.nip = value.length > 0;
                    formFieldError.nip = formFieldValid.nip ? '' : '';

                    if (formFieldValid.nip) {
                        formFieldValid.nip = isValidNip(value)
                        formFieldError.nip = formFieldValid.nip ? '' : 'Nip jest niepoprawny';
                    }

                } else {
                    formFieldValid.nip = true;
                    formFieldError.nip = '';
                }

                break;
            case 'email':

                if (selectedCreationType.isEmailRequired) {

                    formFieldValid.email = value.length > 0;
                    formFieldError.email = formFieldValid.email ? '' : '';

                    if (formFieldValid.email) {
                        formFieldValid.email = isValidEmail(value);
                        formFieldError.email = formFieldValid.email ? '' : 'Email jest niepoprawny';
                    }

                } else {
                    formFieldValid.email = true;
                    formFieldError.email = '';
                }

                break;
            case 'contactName':
                if (selectedCreationType.isContactPersonRequired) {
                    formFieldValid.contactName = value.length > 0;
                    formFieldError.contactName = formFieldValid.contactName ? '' : '';
                } else {
                    formFieldValid.contactName = true;
                    formFieldError.contactName = '';
                }

                break;

            case 'contactPhoneNumber':
                if (selectedCreationType.isContactPersonRequired) {
                    formFieldValid.contactPhoneNumber = value.length > 0;
                    formFieldError.contactPhoneNumber = formFieldValid.contactPhoneNumber ? '' : '';

                    if (formFieldValid.contactPhoneNumber) {
                        formFieldValid.contactPhoneNumber = value.length === 9;
                        formFieldError.contactPhoneNumber = formFieldValid.contactPhoneNumber ? '' : 'Numer telefonu musi zawierać 9 cyfr';
                    }

                } else {
                    formFieldValid.contactPhoneNumber = true;
                    formFieldError.contactPhoneNumber = '';
                }

                break;
            case 'contactEmail':
                if (selectedCreationType.isContactPersonRequired) {
                    formFieldValid.contactEmail = value.length > 0;
                    formFieldError.contactEmail = formFieldValid.contactEmail ? '' : '';

                    if (formFieldValid.contactEmail) {
                        formFieldValid.contactEmail = isValidEmail(value);
                        formFieldError.contactEmail = formFieldValid.contactEmail ? '' : 'Email jest niepoprawny';
                    }

                } else {
                    formFieldValid.contactEmail = true;
                    formFieldError.contactEmail = '';
                }

                break;
            case 'invoiceEmail':
                if (selectedCreationType.isBillingInfoRequired) {
                    formFieldValid.invoiceEmail = value.length > 0;
                    formFieldError.invoiceEmail = formFieldValid.invoiceEmail ? '' : '';

                    if (formFieldValid.invoiceEmail) {
                        formFieldValid.invoiceEmail = isValidEmail(value);
                        formFieldError.invoiceEmail = formFieldValid.invoiceEmail ? '' : 'Email jest niepoprawny';
                    }

                } else {
                    formFieldValid.invoiceEmail = true;
                    formFieldError.invoiceEmail = '';
                }

                break;
            case 'bankAccount':
                if (selectedCreationType.isBillingInfoRequired) {
                    formFieldValid.bankAccount = value.length > 0;
                    formFieldError.bankAccount = formFieldValid.bankAccount ? '' : '';

                    if (formFieldValid.bankAccount) {
                        formFieldValid.bankAccount = isValidDigitCount(value, 26);
                        formFieldError.bankAccount = formFieldValid.bankAccount ? '' : 'Numer konta musi zawierać 26 cyfr';
                    }

                } else {
                    formFieldValid.bankAccount = true;
                    formFieldError.bankAccount = '';
                }

                break;
            case 'postCode':
                if (selectedCreationType.isAddressRequired) {
                    formFieldValid.postCode = value.length > 0;
                    formFieldError.postCode = formFieldValid.postCode ? '' : '';

                    if (formFieldValid.postCode) {
                        formFieldValid.postCode = isValidDigitCount(value, 5);
                        formFieldError.postCode = formFieldValid.postCode ? '' : 'Kod pocztowy musi zawierać 5 cyfr';
                    }

                } else {
                    formFieldValid.postCode = true;
                    formFieldError.postCode = '';
                }

                break;
            case 'street':
                if (selectedCreationType.isAddressRequired) {
                    formFieldValid.street = value.length > 0;
                    formFieldError.street = formFieldValid.street ? '' : '';
                } else {
                    formFieldValid.street = true;
                    formFieldError.street = '';
                }

                break;
            case 'city':
                if (selectedCreationType.isAddressRequired) {
                    formFieldValid.city = value.length > 0;
                    formFieldError.city = formFieldValid.city ? '' : '';
                }
                else {
                    formFieldValid.city = true;
                    formFieldError.city = '';
                }

                break;

            case 'representativePesel':

                if (selectedBusinessType.isRepresentativeRequired && selectedCreationType.isRepresentativeRequired) {

                    formFieldValid.representativePesel = value.length > 0;
                    formFieldError.representativePesel = formFieldValid.representativePesel ? '' : '';

                    if (formFieldValid.representativePesel) {
                        formFieldValid.representativePesel = value.length === 11;
                        formFieldError.representativePesel = formFieldValid.representativePesel ? '' : 'Pesel musi zawierać 11 cyfr';
                    }

                    if (formFieldValid.representativePesel) {
                        formFieldValid.representativePesel = isValidPesel(value)
                        formFieldError.representativePesel = formFieldValid.representativePesel ? '' : 'Pesel jest niepoprawny';
                    }

                } else {
                    formFieldValid.representativePesel = true;
                    formFieldError.representativePesel = '';
                }

                break;

            case 'representativeName':
                if (selectedBusinessType.isRepresentativeRequired && selectedCreationType.isRepresentativeRequired) {
                    formFieldValid.representativeName = value.length > 0;
                    formFieldError.representativeName = formFieldValid.representativeName ? '' : '';
                } else {
                    formFieldValid.representativeName = true;
                    formFieldError.representativeName = '';
                }

                break;
            default:
                break;
        }

        if (!skipFormValidation) {
            this.setState({
                formFieldError: formFieldError,
                formFieldValid: formFieldValid
            }, this.validateForm)
        } else {
            this.setState({
                formFieldError: formFieldError,
                formFieldValid: formFieldValid
            })
        }

    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit(this.props.restaurantId, this.state.merchant);
    };

    handleCancel = e => {
        this.props.onCancel();
    };

    /**
     * Obsługa zmiany pól tekstowych
     */
    handleInputChange = e => {

        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        switch (name) {
            case 'p24MerchantId':
            case 'pesel':
            case 'representativePesel':
            case 'krs':
            case 'regon':
            case 'phoneNumber':
            case 'contactPhoneNumber':
            case 'bankAccount':
                //dopuszczamy tylko pusty string, cyfry
                if (value === '' || numberOnlyRegExp.test(value)) {
                    let merchant = { ...this.state.merchant, [name]: value };
                    this.setState({ merchant }, () => { this.validateField(name, value) });
                }

                break;
            case 'postCode':
            case 'nip':

                //dopuszczamy tylko pusty string, cyfry, -
                if (value === '' || numberOrDashRegExp.test(value)) {
                    let merchant = { ...this.state.merchant, [name]: value };
                    this.setState({ merchant }, () => { this.validateField(name, value) });
                }
                break;
            default:
                let merchant = { ...this.state.merchant, [name]: value };
                this.setState({ merchant }, () => { this.validateField(name, value) });
                break;
        }


    };

    /**
     * Obsluga zmiany rodzaju działalności
     * 
     * Dodatkowo czyści pole Nip/Pesel/Regon/Krs jeśli było wypełnione, a po zmianie rodzaju działalnośći już nie musi
     * 
     */
    handleSelectChangeOnBusinessType = selectedOption => {

        if (selectedOption) {

            let merchant = {
                ...this.state.merchant,
                businessType: selectedOption.id
            };

            //sprawdzamy czy nalezy zresetowac pesel
            if (this.state.selectedBusinessType.isPeselRequired && !selectedOption.isPeselRequired) {
                //po zmianie typu, pesel nie jest juz wymagany, wiec go resetujemy
                merchant.pesel = '';
            }

            //sprawdzamy czy nalezy zresetowac nip
            if (this.state.selectedBusinessType.isNipRequired && !selectedOption.isNipRequired) {
                //po zmianie typu, nip nie jest juz wymagany, wiec go resetujemy
                merchant.nip = '';
            }

            //sprawdzamy czy nalezy zresetowac regon
            if (this.state.selectedBusinessType.isRegonRequired && !selectedOption.isRegonRequired) {
                //po zmianie typu, regon nie jest juz wymagany, wiec go resetujemy
                merchant.regon = '';
            }

            //sprawdzamy czy nalezy zresetowac nip
            if (this.state.selectedBusinessType.isKrsRequired && !selectedOption.isKrsRequired) {
                //po zmianie typu, krs nie jest juz wymagany, wiec go resetujemy
                merchant.krs = '';
            }

            //sprawdzamy czy nalezy zresetowac reprezentatnta
            if (this.state.selectedBusinessType.isRepresentativeRequired && !selectedOption.isRepresentativeRequired) {
                //po zmianie typu, reprezentant nie jest juz wymagany, wiec go resetujemy
                merchant.representativeName = '';
                merchant.representativePesel = '';
            }

            this.setState({ merchant, selectedBusinessType: selectedOption }, () => {
                //kazde pole walidujemy, a na koncu walidujemy formularz
                this.validateField('pesel', merchant.pesel, true);
                this.validateField('nip', merchant.nip, true);
                this.validateField('regon', merchant.regon, true);
                this.validateField('krs', merchant.krs, true);
                this.validateField('representativeName', merchant.representativeName, true);
                this.validateField('representativePesel', merchant.representativePesel, true);
                this.validateForm();

            });
        }

    };

    /**
    * Obsluga zmiany branzy
    * 
    */
    handleSelectChangeOnTrade = selectedOption => {

        if (selectedOption) {

            let merchant = {
                ...this.state.merchant,
                trade: selectedOption.id
            };

            this.setState({ merchant, selectedTrade: selectedOption });
        }

    };

    /**
   * Obsluga zmiany typu utworzenia
   * 
   */
    handleSelectChangeOnCreationType = selectedOption => {

        if (selectedOption) {

            let merchant = {
                ...this.state.merchant,
                creationType: selectedOption.id
            };

            //sprawdzamy czy nalezy zresetowac p24MerchantId
            if (this.state.selectedCreationType.isP24MerchantRequired && !selectedOption.isP24MerchantRequired) {
                //po zmianie typu, p24Merchant nie jest juz wymagany, wiec go resetujemy
                merchant.p24MerchantId = '';
            }

            //sprawdzamy czy nalezy zresetowac name
            if (this.state.selectedCreationType.isNameRequired && !selectedOption.isNameRequired) {
                //po zmianie typu, name nie jest juz wymagany, wiec go resetujemy
                merchant.name = '';
            }

            //sprawdzamy czy nalezy zresetowac email
            if (this.state.selectedCreationType.isEmailRequired && !selectedOption.isEmailRequired) {
                //po zmianie typu, name nie jest juz wymagany, wiec go resetujemy
                merchant.email = '';
            }

            //sprawdzamy czy nalezy zresetowac phoneNumber
            if (this.state.selectedCreationType.isPhoneNumberRequired && !selectedOption.isPhoneNumberRequired) {
                //po zmianie typu, phoneNumber nie jest juz wymagany, wiec go resetujemy
                merchant.phoneNumber = '';
            }

            //sprawdzamy czy nalezy zresetowac adres
            if (this.state.selectedCreationType.isAddressRequired && !selectedOption.isAddressRequired) {
                //po zmianie typu, address nie jest juz wymagany, wiec go resetujemy
                merchant.street = '';
                merchant.postCode = '';
                merchant.city = '';
            }

            //sprawdzamy czy nalezy zresetowac contactPerson
            if (this.state.selectedCreationType.isContactPersonRequired && !selectedOption.isContactPersonRequired) {
                //po zmianie typu, contactPerson nie jest juz wymagany, wiec go resetujemy
                merchant.contactEmail = '';
                merchant.contactName = '';
                merchant.contactPhoneNumber = '';
            }

            //sprawdzamy czy nalezy zresetowac billingInfo
            if (this.state.selectedCreationType.isBillingInfoRequired && !selectedOption.isBillingInfoRequired) {
                //po zmianie typu, billingInfo nie jest juz wymagany, wiec go resetujemy
                merchant.invoiceEmail = '';
                merchant.bankAccount = '';
            }

            //sprawdzamy czy nalezy zresetowac reprezentatnta
            if (this.state.selectedCreationType.isRepresentativeRequired && !selectedOption.isRepresentativeRequired) {
                //po zmianie typu, reprezentant nie jest juz wymagany, wiec go resetujemy
                merchant.representativeName = '';
                merchant.representativePesel = '';
            }

            this.setState({ merchant, selectedCreationType: selectedOption }, () => {
                //kazde pole walidujemy, a na koncu walidujemy formularz
                this.validateField('p24MerchantId', merchant.p24MerchantId, true);

                this.validateField('name', merchant.name, true);
                this.validateField('email', merchant.email, true);
                this.validateField('phoneNumber', merchant.phoneNumber, true);

                this.validateField('street', merchant.street, true);
                this.validateField('postCode', merchant.postCode, true);
                this.validateField('city', merchant.city, true);

                this.validateField('invoiceEmail', merchant.invoiceEmail, true);
                this.validateField('bankAccount', merchant.bankAccount, true);

                this.validateField('contactEmail', merchant.contactEmail, true);
                this.validateField('contactName', merchant.contactName, true);
                this.validateField('contactPhoneNumber', merchant.contactPhoneNumber, true);

                this.validateField('representativeName', merchant.representativeName, true);
                this.validateField('representativePesel', merchant.representativePesel, true);

                this.validateForm();
            });
        }

    };

    /**
    * Dane P24
    */
    p24InfoComponent = () => {
        return (
            <div className="w3-col s8">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h5 className="w3-center">Przelewy 24</h5>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s6">
                            <input
                                className="w3-input"
                                type="text"
                                name="p24MerchantId"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.p24MerchantId}
                                disabled={!this.state.selectedCreationType.isP24MerchantRequired || this.props.disabledFields.includes('p24MerchantId')}
                                maxLength="9"
                            ></input>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.p24MerchantId"
                                    defaultMessage="Przelewy24 Id"
                                />
                                <ValidationMessage isValid={this.state.formFieldValid.p24MerchantId} message={this.state.formFieldError.p24MerchantId} />
                            </label>
                        </div>

                        <div className="w3-col s12">
                            <Select

                                styles={selectStyles}
                                value={this.state.selectedCreationType}
                                name="creationType"
                                onChange={this.handleSelectChangeOnCreationType}
                                options={P24MerchantCreationTypeList}
                                getOptionLabel={option => option.displayText}
                                getOptionValue={option => option.id}
                                isDisabled={this.props.disabledFields.includes('creationType')}
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.creationType"
                                    defaultMessage="creationType"
                                />
                                <span className="w3-text-pink">*</span>
                            </label>
                        </div>

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="p24Link"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.p24Link}
                                disabled={true}
                            ></input>
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.p24Link"
                                    defaultMessage="p24Link"
                                />
                            </label>
                        </div>

                    </div>

                </div>
            </div>
        )
    }

    /**
     * Dane podstawowe
     */
    basicInfoComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h5 className="w3-center">Dane podstawowe</h5>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="name"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.name}
                                maxLength="200"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.name"
                                    defaultMessage="Name"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.name} message={this.state.formFieldError.name} />
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="email"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.email}
                                maxLength="45"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.email"
                                    defaultMessage="Email"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.email} message={this.state.formFieldError.email} />
                            </label>
                        </div>

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="phoneNumber"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.phoneNumber}
                                maxLength="9"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.phoneNumber"
                                    defaultMessage="phoneNumber"
                                />
                                {this.state.selectedCreationType.isPhoneNumberRequired && <span className="w3-text-pink">*</span>}
                                <ValidationMessage isValid={this.state.formFieldValid.phoneNumber} message={this.state.formFieldError.phoneNumber} />
                            </label>
                        </div>

                    </div>
                </div>

            </div>
        )
    }

    /**
     * Dane biznesowe
     */
    businessInfoComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h4 className="w3-center">Dane biznesowe</h4>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <Select

                                styles={selectStyles}
                                value={this.state.selectedBusinessType}
                                name="businessType"
                                onChange={this.handleSelectChangeOnBusinessType}
                                options={P24MerchantBusinessTypeList}
                                getOptionLabel={option => option.displayText}
                                getOptionValue={option => option.id}
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.businessType"
                                    defaultMessage="businessType"
                                />
                                <span className="w3-text-pink">*</span>
                            </label>
                        </div>


                    </div>

                    {this.state.selectedBusinessType.isPeselRequired && <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="pesel"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.pesel}
                                maxLength="11"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.pesel"
                                    defaultMessage="pesel"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.pesel} message={this.state.formFieldError.pesel} />
                            </label>
                        </div>

                    </div>}

                    {this.state.selectedBusinessType.isNipRequired && <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="nip"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.nip}
                                maxLength="20"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.nip"
                                    defaultMessage="nip"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.nip} message={this.state.formFieldError.nip} />
                            </label>
                        </div>

                    </div>
                    }

                    {this.state.selectedBusinessType.isRegonRequired && <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="regon"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.regon}
                                maxLength="14"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.regon"
                                    defaultMessage="regon"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.regon} message={this.state.formFieldError.regon} />
                            </label>
                        </div>

                    </div>
                    }

                    {this.state.selectedBusinessType.isKrsRequired && <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="krs"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.krs}
                                maxLength="10"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.krs"
                                    defaultMessage="krs"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.krs} message={this.state.formFieldError.krs} />
                            </label>
                        </div>

                    </div>
                    }

                </div>

            </div>
        )
    }

    /**
    * Działalność
    */
    businessTypeComponent = () => {
        return (
            <div className="w3-col s4">


                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h5 className="w3-center">Opis działalności</h5>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s12">
                            <Select

                                styles={selectStyles}
                                value={this.state.selectedTrade}
                                name="trade"
                                onChange={this.handleSelectChangeOnTrade}
                                options={P24MerchantTradeList}
                                getOptionLabel={option => option.displayText}
                                getOptionValue={option => option.id}
                                isDisabled={true}
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.trade"
                                    defaultMessage="trade"
                                />
                                <span className="w3-text-pink">*</span>
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="shopUrl"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.shopUrl}
                                maxLength="100"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.shopUrl"
                                    defaultMessage="shopUrl"
                                />
                                <span className="w3-text-pink">*</span>
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <textarea
                                className="w3-input w3-border"
                                type="text"
                                name="servicesDescription"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.servicesDescription}
                                maxLength="200"
                                style={{ resize: 'none' }}
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.servicesDescription"
                                    defaultMessage="servicesDescription"
                                />
                            </label>
                        </div>

                    </div>

                </div>
            </div>
        )
    }

    contactPersonComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h4 className="w3-center">Osoba kontaktowa</h4>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="contactName"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.contactName}
                                maxLength="200"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.contactName"
                                    defaultMessage="contactName"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.contactName} message={this.state.formFieldError.contactName} />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="contactEmail"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.contactEmail}
                                maxLength="45"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.contactEmail"
                                    defaultMessage="contactEmail"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.contactEmail} message={this.state.formFieldError.contactEmail} />
                            </label>
                        </div>

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="contactPhoneNumber"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.contactPhoneNumber}
                                maxLength="9"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.contactPhoneNumber"
                                    defaultMessage="contactPhoneNumber"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.contactPhoneNumber} message={this.state.formFieldError.contactPhoneNumber} />
                            </label>
                        </div>
                    </div>

                </div>

            </div>
        )
    }

    addressComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h4 className="w3-center">Adres</h4>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s4">
                            <input
                                className="w3-input"
                                type="text"
                                name="country"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.country}
                                maxLength="100"
                                readOnly
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.country"
                                    defaultMessage="country"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.country} message={this.state.formFieldError.country} />
                            </label>
                        </div>

                        <div className="w3-col s8">
                            <input
                                className="w3-input"
                                type="text"
                                name="street"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.street}
                                maxLength="200"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.street"
                                    defaultMessage="street"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.street} message={this.state.formFieldError.street} />
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s4">
                            <input
                                className="w3-input"
                                type="text"
                                name="postCode"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.postCode}
                                maxLength="6"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.postCode"
                                    defaultMessage="postCode"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.postCode} message={this.state.formFieldError.postCode} />
                            </label>
                        </div>

                        <div className="w3-col s8">
                            <input
                                className="w3-input"
                                type="text"
                                name="city"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.city}
                                maxLength="100"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.city"
                                    defaultMessage="city"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.city} message={this.state.formFieldError.city} />
                            </label>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

    /**
     * Dane rozliczeniowe
     */
    billingInfoComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h5 className="w3-center">Dane rozliczeniowe</h5>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="bankAccount"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.bankAccount}
                                maxLength="26"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.bankAccount"
                                    defaultMessage="bankAccount"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.bankAccount} message={this.state.formFieldError.bankAccount} />
                            </label>
                        </div>

                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="invoiceEmail"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.invoiceEmail}
                                maxLength="45"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.invoiceEmail"
                                    defaultMessage="invoiceEmail"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.invoiceEmail} message={this.state.formFieldError.invoiceEmail} />
                            </label>
                        </div>

                    </div>
                </div>

            </div>
        )
    }

    representativeComponent = () => {
        return (
            <div className="w3-col s4">

                <div className="w3-card-4">
                    <div className="w3-container w3-theme-l3">
                        <h4 className="w3-center">Reprezentant</h4>
                    </div>

                    <div className="w3-row-padding">
                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="representativeName"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.representativeName}
                                maxLength="200"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.representativeName"
                                    defaultMessage="representativeName"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.representativeName} message={this.state.formFieldError.representativeName} />
                            </label>
                        </div>
                    </div>

                    <div className="w3-row-padding">

                        <div className="w3-col s12">
                            <input
                                className="w3-input"
                                type="text"
                                name="representativePesel"
                                onChange={this.handleInputChange}
                                value={this.state.merchant.representativePesel}
                                maxLength="11"
                            />
                            <label className="w3-text-theme w3-small">
                                <FormattedMessage
                                    id="p24Merchant.representativePesel"
                                    defaultMessage="representativePesel"
                                />
                                <span className="w3-text-pink">*</span>
                                <ValidationMessage isValid={this.state.formFieldValid.representativePesel} message={this.state.formFieldError.representativePesel} />
                            </label>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

    render() {
        return (
            <div className="w3-card-4">
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title}</h2>
                </div>

                <div className="w3-padding" style={{ overflowY: 'auto', height: '700px' }}>

                    <div className="w3-container">
                        <p>Poniższe danę służą do rejestracji w systemie Przelewy24. Dalsza ich modyfikacja nie ma wpływu na dane przechowywane na serwerach P24, a ich modyfikację należy dokonywać w panelu P24.</p>
                    </div>

                    <div className="w3-row-padding">
                        <this.p24InfoComponent />
                    </div>

                    <br />

                    <div className="w3-row-padding">

                        {this.state.selectedCreationType.isBasicInfoRequired && <this.basicInfoComponent />}

                        {this.state.selectedCreationType.isBusinessInfoRequired && <this.businessInfoComponent />}

                        {this.state.selectedCreationType.isBusinessTypeRequired && <this.businessTypeComponent />}


                    </div>

                    <br />

                    {this.props.extendedView && <div className="w3-row-padding">

                        {this.state.selectedCreationType.isBillingInfoRequired && <this.billingInfoComponent />}

                        {this.state.selectedCreationType.isAddressRequired && <this.addressComponent />}

                        {this.state.selectedCreationType.isContactPersonRequired && <this.contactPersonComponent />}

                    </div>}

                    {this.props.extendedView && (this.state.selectedBusinessType.isRepresentativeRequired && this.state.selectedCreationType.isRepresentativeRequired) && <div className="w3-row-padding"><this.representativeComponent /></div>}

                </div>

                <br />

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                            disabled={!this.state.formValid}
                        >
                            {this.props.sumbitText}
                        </button>
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="reset"
                            onClick={this.handleCancel}
                        >
                            {this.props.cancelText}
                        </button>
                    </div>
                </form>


            </div>
        )
    }
}

//ustawienie domyslnych pol dla rejestracji nowego merchanta
P24MerchantForm.defaultProps = {
    merchant: {
        p24MerchantId: '',
        businessType: P24MerchantBusinessType._3.id,
        name: '',
        email: '',
        pesel: '',
        nip: '',
        krs: '',
        regon: '',
        phoneNumber: '',
        bankAccount: '',
        invoiceEmail: '',
        shopUrl: '',
        servicesDescription: '',
        trade: P24MerchantTrade.serint.id,
        country: 'PL',
        city: '',
        postCode: '',
        street: '',
        contactName: '',
        contactEmail: '',
        contactPhoneNumber: '',
        representativeName: '',
        representativePesel: '',
        creationType: P24MerchantCreationType.P24.id,

    },
    extendedView: true,
    //domyślnie wszystkie do edycji
    disabledFields: []
}

P24MerchantForm.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //identyfikator restauracji
    restaurantId: PropTypes.number.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    merchant: PropTypes.object.isRequired,
    //akcja zwrotna na anuluj
    onCancel: PropTypes.func.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji anuluj
    cancelText: PropTypes.string.isRequired,
    //tekst na akcji zapisz
    sumbitText: PropTypes.string.isRequired,
    //czy widok rozszerzony
    extendedView: PropTypes.bool.isRequired,
    //tablica z polami merchanta, ktora musza byc disablowane (tryb edycji/kasowania/odłańczania/dołańczania)
    disabledFields: PropTypes.array,
}

export default P24MerchantForm